<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <mat-dialog-content class="mat-typography">
    <h2 mat-dialog-title #fileUploadDialog>Attach Files: {{ label }}</h2>
    <div class="instruction-prompt">
      <strong>AI Prompt:</strong>
      <div>"{{prompt}}"</div>
    </div>

    @if (files.length > 0) {

    <div class="file-list">
      <h3>Selected Files:</h3>
      <div class="attachments">
        @for (file of files; track file; let idx = $index) {
          <div class="attachment">
            <button kendoButton type="button" #tooltip="matTooltip" aria-label="Remove attachment"
                    matTooltip="Remove attachment" matTooltipPosition="above" (click)="removeFile(idx)"
                    [svgIcon]="minusOutlineIcon" fillMode="clear"></button>
            <attachment-doc [document]="file"></attachment-doc>
          </div>
        }
      </div>
    </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button matButton type="button" (click)="cancel()">{{cancelButtonText}}</button>
    <button matButton="tonal" type="button" (click)="openDocumentManager()" class="btn-action">
      <mat-icon>attach_file</mat-icon>
      Attach Files
    </button>
    <button matButton="filled" type="button" class="btn-action" [disabled]="files.length === 0" (click)="submit()">
      Continue
    </button>
  </mat-dialog-actions>
</div>
